<template lang="pug">
div
  p Consider the Schrödinger equation on <mj :m="`\\Omega = [-4.0;4.0]\\times[-4.0;${ymax.toFixed(1)}]`"/>
    mj(display) -\nabla^2\psi_i + (1+x^2)(1+y^2)\psi_i = \lambda_i\psi_i

  div(
    style="display: flex; flex-direction: row; justify-content: space-between"
  )
    div(v-for="i of [0,1,2,3]", :key="`s${i}`")
      ntc_canvas(
        :index="i",
        :ymax="ymax",
        style="width: 160px; height: 160px",
        :canvasScale="canvasScale",
        @echanged="(E) => eChanged(i, E)"
      )
      div(style="padding: 10px 0 0 30px")
        mj \lambda_{{ i }} =
        | &nbsp;
        mj(:m="Es[i].toFixed(3)")
</template>

<script>
import NTCCanvas from "./NewToolCountingCanvas.vue";
import Animation from "./Animation.vue";
import MathJax from "./MathJax.vue";

const cycleTime = 15000;

export default {
  props: {
    canvasScale: {
      value: 1,
      type: Number,
    },
    step: {
      value: 1,
      type: Number,
    },
  },
  mixins: [Animation],
  components: { ntc_canvas: NTCCanvas, mj: MathJax },
  created() {
    this.$on("tick", () => {
      if (this.time >= cycleTime) {
        this.stopAnimation();
        this.time = cycleTime;
      }
    });
  },
  mounted() {
    this.updateStep();
  },
  data() {
    return {
      grow: false,
      Es: [0, 0, 0, 0],
    };
  },
  watch: {
    step() {
      this.updateStep();
    },
  },
  computed: {
    ymax() {
      const t = (1 + Math.cos((this.time / cycleTime) * Math.PI)) / 2;

      if (this.grow) return 4 - 6 * t;
      return -2 + 6 * t;
    },
  },
  methods: {
    eChanged(i, E) {
      this.Es = this.Es.map((Ej, j) => (i == j ? E : Ej));
    },
    updateStep() {
      if (this.step == 1) {
        this.stopAnimation();
        this.grow = false;
        this.time = 0;
      } else if (this.step == 2) {
        this.grow = false;
        this.startAnimation();
      } else if (this.step == 3) {
        this.grow = true;
        this.startAnimation();
      }
    },
  },
};
</script>